<ng-container *ngIf="esEncuesta">
  <div class="d-flex justify-content-center">
    <h1>Encuesta de Satisfacción</h1>
  </div>
  <div class="d-flex justify-content-center">
    <label
      >{{ currentQuestion.msg_input }}</label
    >
  </div>
  <div class="d-flex justify-content-center mt-3">
    <div class="encuesta-container" *ngIf="isLoaded">
      <h2 >{{ currentQuestion.description }}</h2>
      <div class="opciones">
        <label *ngFor="let opcion of currentQuestion.options" class="opcion">
          <input
            *ngIf="!opcion.abierta"
            type="radio"
            name="encuesta"
            [value]="opcion.descripcion"
            (change)="onSeleccionarRespuesta(opcion)"
            [checked]="respuestas[currentQuestion.id] === opcion.descripcion" />
          {{ opcion.descripcion }}

          <textarea
            *ngIf="opcion.abierta"
            class="form-control"
            rows="3"
            placeholder="Escribe tu respuesta aquí..."
            (input)="onRespuestaAbierta($event)"></textarea>

        </label>
      </div>
      <div class="buttons">
        <button (click)="onAnterior()" [disabled]="currentQuestionIndex === 0">
          Anterior
        </button>
        <button
          *ngIf="currentQuestionIndex < questions.length - 1"
          (click)="onSiguiente()">
          Siguiente
        </button>
        <button
          *ngIf="currentQuestionIndex === questions.length - 1"
          (click)="onEnviarEncuesta()">
          Enviar
        </button>
      </div>
    </div>
    <div *ngIf="!isLoaded">
      <p>Cargando encuesta...</p>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!esEncuesta">
  <div class="d-flex justify-content-center">
    <label>Gracias por responder la encuesta.</label>
  </div>
</ng-container>
